"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  LayersSelectFront: ['layers-select-front', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22,18H8a2,2,0,0,1-2-2V2A2,2,0,0,1,8,0H22a2,2,0,0,1,2,2V16A2,2,0,0,1,22,18ZM8,15.5a.5.5,0,0,0,.5.5l13,0a.5.5,0,0,0,.5-.5V2.5a.5.5,0,0,0-.5-.5H8.5a.5.5,0,0,0-.5.5Z', 'M3,24H2a2,2,0,0,1-2-2V21a1,1,0,0,1,2,0v.5a.5.5,0,0,0,.5.5H3a1,1,0,0,1,0,2Z', 'M1,17a1,1,0,0,1-1-1V14a1,1,0,0,1,2,0v2A1,1,0,0,1,1,17Z', 'M1,10A1,1,0,0,1,0,9V7A1,1,0,0,1,2,7V9A1,1,0,0,1,1,10Z', 'M10,24H8a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z', 'M17,24H15a1,1,0,0,1,0-2h2a1,1,0,0,1,0,2Z']],
  Layers: ['layers', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.07,9.144l-9.64,4.6a.99.99,0,0,1-.86,0l-9.639-4.6a1,1,0,1,0-.861,1.8l9.638,4.6a3,3,0,0,0,2.584,0l9.639-4.6a1,1,0,0,0-.861-1.8Z', 'M22.07,13.186l-9.64,4.6a1,1,0,0,1-.86,0l-9.639-4.6a1,1,0,0,0-.861,1.8l9.638,4.6a3,3,0,0,0,2.584,0l9.639-4.6a1,1,0,0,0-.861-1.8Z', 'M22.07,17.051l-9.64,4.6a.99.99,0,0,1-.86,0l-9.639-4.6a1,1,0,0,0-.861,1.806l9.638,4.6a2.986,2.986,0,0,0,2.584,0l9.639-4.6a1,1,0,0,0-.861-1.806Z', 'M1.156,7.444,10.8,11.639a3.008,3.008,0,0,0,2.392,0l9.645-4.193a1.5,1.5,0,0,0,0-2.752L13.2.5A3.005,3.005,0,0,0,10.8.5L1.158,4.693a1.5,1.5,0,0,0,0,2.751Z']],
  LayersBack: ['layers-back', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M0.000 0.000 L17.000 0.000 L17.000 17.000 L-0.000 17.000 Z', 'M21.5,7h-2a1,1,0,0,0,0,2h2a.5.5,0,0,1,.5.5v12a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5v-2a1,1,0,0,0-2,0v2A2.5,2.5,0,0,0,9.5,24h12A2.5,2.5,0,0,0,24,21.5V9.5A2.5,2.5,0,0,0,21.5,7Z']],
  LayersLock: ['layers-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.5,15.5a.25.25,0,0,1-.25-.25v-1a3.25,3.25,0,0,0-6.5,0v1a.25.25,0,0,1-.25.25A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17A1.5,1.5,0,0,0,22.5,15.5ZM20,20.25a1,1,0,1,1-1-1A1,1,0,0,1,20,20.25Zm-2.75-6a1.75,1.75,0,0,1,3.5,0v1a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25Z', 'M7.5,7.5A4.5,4.5,0,1,0,12,3,4.505,4.505,0,0,0,7.5,7.5ZM12,6a1.5,1.5,0,0,0-1.5,1.5.5.5,0,1,1-1,0A2.5,2.5,0,0,1,12,5a.5.5,0,1,1,0,1Z', 'M14.49,13.757a1,1,0,0,0-1.129-.853c-3.852.541-7.615-1.184-11.07-5.069a.5.5,0,0,1,0-.664C5.338,3.739,8.6,2,12,2s6.662,1.738,9.711,5.166a.5.5,0,0,1,0,.666c-.133.149-.281.308-.441.477a1,1,0,1,0,1.445,1.382c.317-.331.583-.633.8-.89a1.988,1.988,0,0,0,0-2.6C19.118,1.075,14.827,0,12,0S4.881,1.076.486,6.2a1.99,1.99,0,0,0,0,2.6C4.881,13.925,9.17,15,12,15a12.08,12.08,0,0,0,1.641-.114A1,1,0,0,0,14.49,13.757Z']],
  Layers1: ['layers-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M21.5,2H9.5A2.5,2.5,0,0,0,7,4.5v8A2.5,2.5,0,0,0,9.5,15h12A2.5,2.5,0,0,0,24,12.5v-8A2.5,2.5,0,0,0,21.5,2ZM22,12.5a.5.5,0,0,1-.5.5H9.5a.5.5,0,0,1-.5-.5v-8A.5.5,0,0,1,9.5,4h12a.5.5,0,0,1,.5.5Z', 'M19.5,15.5a1,1,0,0,0-.98.8.249.249,0,0,1-.245.2H5.75a.25.25,0,0,1-.25-.25V7.725a.25.25,0,0,1,.2-.245A1,1,0,0,0,5.5,5.5a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2h13a2,2,0,0,0,2-2A1,1,0,0,0,19.5,15.5Z', 'M16,19a1,1,0,0,0-.98.8.249.249,0,0,1-.245.2H2.25A.25.25,0,0,1,2,19.75V11.225a.25.25,0,0,1,.2-.245A1,1,0,0,0,2,9a2,2,0,0,0-2,2v9a2,2,0,0,0,2,2H15a2,2,0,0,0,2-2A1,1,0,0,0,16,19Z']],
  LayersFront: ['layers-front', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15,17a2,2,0,0,0,2-2V2a2,2,0,0,0-2-2H2A2,2,0,0,0,0,2V15a2,2,0,0,0,2,2ZM2,2.5A.5.5,0,0,1,2.5,2h12a.5.5,0,0,1,.5.5v12a.5.5,0,0,1-.5.5H2.5a.5.5,0,0,1-.5-.5Z', 'M24,9.5A2.5,2.5,0,0,0,21.5,7H19.675a1.023,1.023,0,0,0-1.175.985V16.5a2,2,0,0,1-2,2H8a1,1,0,0,0-1,1v2A2.5,2.5,0,0,0,9.5,24h12A2.5,2.5,0,0,0,24,21.5Z']],
  LayersOff: ['layers-off', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M15.176,10.826a.249.249,0,0,0,.276.053L22.991,7.6a1.5,1.5,0,0,0,0-2.751L13.342.655a3.013,3.013,0,0,0-2.392,0L7.143,2.31a.25.25,0,0,0-.077.406Z', 'M1.115,5.251a.25.25,0,0,0-.369.017A1.5,1.5,0,0,0,1.3,7.6L3.922,8.74A.25.25,0,0,0,4.2,8.334Z', 'M22.987,13.6a1.5,1.5,0,0,0,0-2.753l-1.245-.542a1,1,0,0,0-.8,1.834l.191.084L18.3,13.463a.251.251,0,0,0-.146.182.254.254,0,0,0,.069.224l1.14,1.14a.252.252,0,0,0,.277.053Z', 'M11.748,15.963,3.154,12.227l.191-.084a1,1,0,0,0-.8-1.834L1.3,10.85a1.5,1.5,0,0,0,0,2.752l9.649,4.2a3.008,3.008,0,0,0,2.392,0,.163.163,0,0,0,.1-.12.16.16,0,0,0-.045-.147l-1.545-1.546C11.815,15.973,11.779,15.977,11.748,15.963Z', 'M23.893,18.18a1.5,1.5,0,0,0-.9-1.375l-1.245-.541a.948.948,0,0,0-.649-.041.25.25,0,0,0-.107.417L23.3,18.953A.25.25,0,0,0,23.7,18.9,1.429,1.429,0,0,0,23.893,18.18Z', 'M12.545,21.917a1,1,0,0,1-.8,0L3.154,18.181l.191-.083a1,1,0,0,0-.8-1.834L1.3,16.805a1.5,1.5,0,0,0,0,2.752l9.649,4.194a3,3,0,0,0,2.392,0L17.377,22a.248.248,0,0,0,.146-.182.251.251,0,0,0-.068-.224l-1.14-1.14a.25.25,0,0,0-.277-.053Z', 'M1.814.293A1,1,0,0,0,.4,1.708l21.5,21.5a1,1,0,1,0,1.414-1.415Z']],
  LayersGridCheck: ['layers-grid-check', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.825a.251.251,0,0,0,.233-.159,8.021,8.021,0,0,1,.456-.97.247.247,0,0,0,0-.248.251.251,0,0,0-.215-.123H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.95a.25.25,0,0,0,.4.2,7.976,7.976,0,0,1,.97-.641.249.249,0,0,0,.128-.218V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.294a.251.251,0,0,0,.228.249,7.935,7.935,0,0,1,1.454.265A.25.25,0,0,0,20,9.568V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.927a.25.25,0,0,0,.229-.349,7.875,7.875,0,0,1-.47-1.455.25.25,0,0,0-.244-.2ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM2,3A1,1,0,0,1,3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm.368,9.079a1.5,1.5,0,0,1-2.261.159l-1.5-1.5a.75.75,0,0,1,1.061-1.06l1.3,1.3a.25.25,0,0,0,.377-.027l2.732-3.643a.75.75,0,1,1,1.2.9Z']],
  LayersGridRemove: ['layers-grid-remove', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.825a.251.251,0,0,0,.233-.159,8.021,8.021,0,0,1,.456-.97.247.247,0,0,0,0-.248.251.251,0,0,0-.215-.123H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.95a.25.25,0,0,0,.4.2,7.976,7.976,0,0,1,.97-.641.249.249,0,0,0,.128-.218V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.294a.251.251,0,0,0,.228.249,7.935,7.935,0,0,1,1.454.265A.25.25,0,0,0,20,9.568V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.927a.25.25,0,0,0,.229-.349,7.875,7.875,0,0,1-.47-1.455.25.25,0,0,0-.244-.2ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-2.651,8.091,1.414-1.414a.252.252,0,0,0,0-.354l-1.414-1.414a.75.75,0,0,1,1.06-1.06l1.414,1.414a.252.252,0,0,0,.354,0l1.414-1.414a.75.75,0,1,1,1.06,1.06l-1.414,1.414a.252.252,0,0,0,0,.354l1.414,1.414a.75.75,0,1,1-1.06,1.06l-1.414-1.414a.252.252,0,0,0-.354,0l-1.414,1.414a.75.75,0,1,1-1.06-1.06Z']],
  LayersGridLock: ['layers-grid-lock', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75h5a.75.75,0,0,0,.75-.75V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.566a.253.253,0,0,0,.089.191.249.249,0,0,0,.2.055,4.073,4.073,0,0,1,1.416,0A.25.25,0,0,0,20,9.566V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3h9.25a.25.25,0,0,0,.25-.25v-1.5a.25.25,0,0,0-.25-.25Zm4.25-6a.25.25,0,0,1-.25.25H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25ZM2,8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8v5a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M19,11a3.244,3.244,0,0,0-3.225,3c-.006.084-.025.164-.025.25v1a.25.25,0,0,1-.25.25A1.5,1.5,0,0,0,14,17v5.5A1.5,1.5,0,0,0,15.5,24h7A1.5,1.5,0,0,0,24,22.5V17a1.5,1.5,0,0,0-1.5-1.5.25.25,0,0,1-.25-.25v-1c0-.086-.019-.166-.025-.25A3.244,3.244,0,0,0,19,11Zm1,9.25a1,1,0,1,1-1-1A1,1,0,0,1,20,20.25Zm.75-6v1a.25.25,0,0,1-.25.25h-3a.25.25,0,0,1-.25-.25v-1a1.708,1.708,0,0,1,.025-.25,1.742,1.742,0,0,1,3.45,0A1.708,1.708,0,0,1,20.75,14.25Z']],
  LayersGridSettings: ['layers-grid-settings', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M10.029,19.277a.254.254,0,0,0-.063-.194A.25.25,0,0,0,9.78,19H8a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.754A.249.249,0,0,0,10,14.5a3.263,3.263,0,0,1,.118-.929.25.25,0,0,0-.042-.218.248.248,0,0,0-.2-.1H8a.25.25,0,0,1-.25-.25V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v3a.25.25,0,0,0,.094.2.247.247,0,0,0,.211.049,3.306,3.306,0,0,1,.929-.072.248.248,0,0,0,.187-.067.251.251,0,0,0,.079-.183V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8v.359a.249.249,0,0,0,.215.247,3.246,3.246,0,0,1,1.393.54.254.254,0,0,0,.259.015A.249.249,0,0,0,20,8.94V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.948a.249.249,0,0,0,.236-.331A3.246,3.246,0,0,1,10.029,19.277ZM6.249,13a.25.25,0,0,1-.25.25H2.249A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25ZM8,6.25A.25.25,0,0,1,7.749,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM17,2a1,1,0,0,1,1,1V6a.25.25,0,0,1-.25.25H14a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,14,2ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.249A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M16.249 17.031 A1.500 1.500 0 1 0 19.249 17.031 A1.500 1.500 0 1 0 16.249 17.031 Z', 'M23.517,15.654a1.782,1.782,0,0,0-1.7-2.953l-1.411.326a.452.452,0,0,1-.533-.31l-.424-1.393a1.775,1.775,0,0,0-3.4,0l-.424,1.393a.453.453,0,0,1-.533.31L13.682,12.7a1.782,1.782,0,0,0-1.7,2.952l.988,1.066a.463.463,0,0,1,0,.625l-.988,1.064a1.782,1.782,0,0,0,1.7,2.953l1.411-.326a.454.454,0,0,1,.533.311l.424,1.391a1.774,1.774,0,0,0,3.4,0l.424-1.392a.451.451,0,0,1,.533-.311l1.411.326a1.782,1.782,0,0,0,1.7-2.952l-.988-1.065a.463.463,0,0,1,0-.625Zm-5.768,4.377a3,3,0,1,1,3-3A3,3,0,0,1,17.749,20.031Z']],
  LayersGridWarning: ['layers-grid-warning', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75h4a.25.25,0,0,1,.25.25v.593a.25.25,0,0,0,.472.116L13.936,13.4a.1.1,0,0,0,0-.1.1.1,0,0,0-.085-.048.1.1,0,0,1-.1-.1V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.865a.25.25,0,0,0,.192.243,2.9,2.9,0,0,1,1.382.77A.25.25,0,0,0,20,10.7V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.793a.253.253,0,0,0,.222-.134l.787-1.5A.251.251,0,0,0,10.58,19Zm4.25-6a.25.25,0,0,1-.25.25H8a.25.25,0,0,1-.25-.25V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25ZM2,8a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v5a.25.25,0,0,1-.25.25H2.249A.25.25,0,0,1,2,13ZM8,6.25A.25.25,0,0,1,7.749,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14a.25.25,0,0,1-.25-.25V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM2,3A1,1,0,0,1,3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.249A.25.25,0,0,1,2,6ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M18.78,12.271a1.45,1.45,0,0,0-2.561,0L11.163,21.9A1.435,1.435,0,0,0,12.444,24H22.555a1.434,1.434,0,0,0,1.28-2.095ZM17.5,14.75a.75.75,0,0,1,.75.75v3a.75.75,0,0,1-1.5,0v-3A.75.75,0,0,1,17.5,14.75Zm-1,6.5a1,1,0,1,1,1,1A1,1,0,0,1,16.5,21.25Z']],
  LayersHide: ['layers-hide', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.25H15a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z', 'M7.5,7.5A4.5,4.5,0,1,0,12,3,4.505,4.505,0,0,0,7.5,7.5ZM12,6a1.5,1.5,0,0,0-1.5,1.5.5.5,0,0,1-1,0A2.5,2.5,0,0,1,12,5a.5.5,0,0,1,0,1Z', 'M9.269,12.618A15.293,15.293,0,0,1,2.29,7.833a.5.5,0,0,1,0-.661C5.341,3.74,8.6,2,12,2s6.659,1.738,9.708,5.168a.5.5,0,0,1,0,.665c-.342.382-.7.752-1.065,1.1a1,1,0,0,0,1.384,1.444c.519-.5,1.018-1.028,1.491-1.579a1.989,1.989,0,0,0,0-2.6C19.119,1.075,14.828,0,12,0S4.881,1.076.486,6.2a1.99,1.99,0,0,0,0,2.6c.958,1.116,3.87,4.512,8.244,5.738a1,1,0,1,0,.54-1.925Z']],
  LayersGridUpload: ['layers-grid-upload', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.932a.094.094,0,0,0,.088-.061,7.963,7.963,0,0,1,.494-1.068.247.247,0,0,0,0-.248.251.251,0,0,0-.215-.123H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.95a.25.25,0,0,0,.4.2,7.976,7.976,0,0,1,.97-.641.249.249,0,0,0,.128-.218V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.294a.251.251,0,0,0,.228.249,7.935,7.935,0,0,1,1.454.265A.25.25,0,0,0,20,9.568V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.927a.25.25,0,0,0,.229-.349,7.889,7.889,0,0,1-.47-1.454.249.249,0,0,0-.244-.2ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-.75,9.5V17.747a.249.249,0,0,0-.245-.249c-1.827-.037-1.646-.5-1.4-.81l2-2.5a.517.517,0,0,1,.782,0l2,2.5c.25.313.431.773-1.4.81a.249.249,0,0,0-.245.249V20.5a.75.75,0,0,1-1.5,0Z']],
  LayersSelect: ['layers-select', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M23,14a1,1,0,0,0-1,1v.5a.5.5,0,0,1-.5.5H21a1,1,0,0,0,0,2h1a2,2,0,0,0,2-2V15A1,1,0,0,0,23,14Z', 'M22,0H21a1,1,0,0,0,0,2h.5a.5.5,0,0,1,.5.5V3a1,1,0,0,0,2,0V2A2,2,0,0,0,22,0Z', 'M7,4A1,1,0,0,0,8,3V2.5A.5.5,0,0,1,8.5,2H9A1,1,0,0,0,9,0H8A2,2,0,0,0,6,2V3A1,1,0,0,0,7,4Z', 'M23,7a1,1,0,0,0-1,1v2a1,1,0,0,0,2,0V8A1,1,0,0,0,23,7Z', 'M16,0H14a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z', 'M8,18H9a1,1,0,0,0,0-2H8.5a.5.5,0,0,1-.5-.5V15a1,1,0,0,0-2,0v1A2,2,0,0,0,8,18Z', 'M7,11a1,1,0,0,0,1-1V8A1,1,0,0,0,6,8v2A1,1,0,0,0,7,11Z', 'M16,16H14a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z', 'M16,22H2.5a.5.5,0,0,1-.5-.5V8A1,1,0,0,0,0,8V22a2,2,0,0,0,2,2H16a1,1,0,0,0,0-2Z']],
  LayersStacked: ['layers-stacked', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.155,7.4l9.649,4.2a3.008,3.008,0,0,0,2.392,0L22.845,7.4a1.5,1.5,0,0,0,0-2.751L13.2.452a3.009,3.009,0,0,0-2.392,0L1.157,4.646a1.5,1.5,0,0,0,0,2.752Z', 'M22.844,10.648,21.6,10.106a1.006,1.006,0,0,0-.8,0L12,13.933,3.2,10.106a1.006,1.006,0,0,0-.8,0l-1.244.541a1.5,1.5,0,0,0,0,2.752L10.8,17.593a3.008,3.008,0,0,0,2.392,0L22.841,13.4a1.5,1.5,0,0,0,0-2.752Z', 'M22.844,16.6,21.6,16.061a1,1,0,0,0-.8,0L12,19.888,3.2,16.061a1,1,0,0,0-.8,0l-1.244.54a1.5,1.5,0,0,0,0,2.752L10.8,23.548a3.008,3.008,0,0,0,2.392,0l9.645-4.193a1.5,1.5,0,0,0,0-2.753Z']],
  LayersShow: ['layers-show', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM20,18.25H18.5a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5Z', 'M7.5,7.5A4.5,4.5,0,1,0,12,3,4.505,4.505,0,0,0,7.5,7.5ZM12,6a1.5,1.5,0,0,0-1.5,1.5.5.5,0,0,1-1,0A2.5,2.5,0,0,1,12,5a.5.5,0,0,1,0,1Z', 'M9.27,12.618A15.316,15.316,0,0,1,2.286,7.833a.5.5,0,0,1,0-.661C5.338,3.74,8.6,2,12,2s6.661,1.738,9.709,5.167a.5.5,0,0,1,0,.666c-.343.382-.7.752-1.068,1.1a1,1,0,0,0,1.384,1.444c.519-.5,1.018-1.028,1.491-1.579a1.989,1.989,0,0,0,0-2.6C19.119,1.075,14.828,0,12,0S4.881,1.076.486,6.2a1.99,1.99,0,0,0,0,2.6c.958,1.116,3.87,4.512,8.245,5.738a.972.972,0,0,0,.27.038,1,1,0,0,0,.27-1.963Z']],
  LayersGridDownload: ['layers-grid-download', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.825a.251.251,0,0,0,.233-.159,8.021,8.021,0,0,1,.456-.97.247.247,0,0,0,0-.248.251.251,0,0,0-.215-.123H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.95a.25.25,0,0,0,.4.2,7.976,7.976,0,0,1,.97-.641.249.249,0,0,0,.128-.218V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.294a.251.251,0,0,0,.228.249,7.935,7.935,0,0,1,1.454.265A.25.25,0,0,0,20,9.568V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.927a.25.25,0,0,0,.229-.349,7.875,7.875,0,0,1-.47-1.455.25.25,0,0,0-.244-.2ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-.391,9.812-2-2.5A.5.5,0,0,1,15.5,17.5h1a.25.25,0,0,0,.25-.25V14.5a.75.75,0,0,1,1.5,0v2.75a.25.25,0,0,0,.25.25h1a.5.5,0,0,1,.391.812l-2,2.5A.5.5,0,0,1,17.109,20.812Z']],
  Layers1Alternate: ['layers-1-alternate', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8.000 2.000 L24.000 2.000 L24.000 14.000 L8.000 14.000 Z', 'M19,15a1,1,0,0,0-.98.8.249.249,0,0,1-.245.2H6.25A.25.25,0,0,1,6,15.75V8.225a.25.25,0,0,1,.2-.245A1,1,0,0,0,6,6,2,2,0,0,0,4,8v8a2,2,0,0,0,2,2H18a2,2,0,0,0,2-2A1,1,0,0,0,19,15Z', 'M15,19a1,1,0,0,0-.98.8.249.249,0,0,1-.245.2H2.25A.25.25,0,0,1,2,19.75V12.225a.25.25,0,0,1,.2-.245A1,1,0,0,0,2,10a2,2,0,0,0-2,2v8a2,2,0,0,0,2,2H14a2,2,0,0,0,2-2A1,1,0,0,0,15,19Z']],
  LayersGridMagnet: ['layers-grid-magnet', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M22.25,10.5h-2a1.752,1.752,0,0,0-1.75,1.75v5a1.25,1.25,0,0,1-2.5,0v-5a1.752,1.752,0,0,0-1.75-1.75h-2a1.752,1.752,0,0,0-1.75,1.75v5a6.75,6.75,0,0,0,13.5,0v-5A1.752,1.752,0,0,0,22.25,10.5Zm-8,4h-2a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25h2a.25.25,0,0,1,.25.25v2A.25.25,0,0,1,14.25,14.5Zm8,0h-2a.25.25,0,0,1-.25-.25v-2a.25.25,0,0,1,.25-.25h2a.25.25,0,0,1,.25.25v2A.25.25,0,0,1,22.25,14.5Z', 'M8.5,14.75a.75.75,0,0,0,0-1.5H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v.5a.75.75,0,0,0,1.5,0V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8v.5a1,1,0,0,0,2,0V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H7.5a1,1,0,0,0,1-1,.978.978,0,0,0-.615-.9.218.218,0,0,1-.135-.2V15A.25.25,0,0,1,8,14.75ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM6.25,18.75A.25.25,0,0,1,6,19H3a1,1,0,0,1-1-1V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25Z']],
  LayersStacked1: ['layers-stacked-1', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M1.155,7.4l9.649,4.2a3.008,3.008,0,0,0,2.392,0L22.845,7.4a1.5,1.5,0,0,0,0-2.751L13.2.452a3.009,3.009,0,0,0-2.392,0L1.157,4.646a1.5,1.5,0,0,0,0,2.752Z', 'M22.844,10.648,21.6,10.106a1,1,0,0,0-.8,1.834l.191.083L12.4,15.759a.989.989,0,0,1-.8,0L3.008,12.023,3.2,11.94a1,1,0,1,0-.8-1.834l-1.244.541a1.5,1.5,0,0,0,0,2.752L10.8,17.593a3.008,3.008,0,0,0,2.392,0L22.841,13.4a1.5,1.5,0,0,0,0-2.752Z', 'M22.844,16.6,21.6,16.061a1,1,0,0,0-.8,1.834l.191.083L12.4,21.714a1,1,0,0,1-.8,0L3.008,17.978,3.2,17.9a1,1,0,0,0-.8-1.834l-1.244.54a1.5,1.5,0,0,0,0,2.752L10.8,23.548a3.008,3.008,0,0,0,2.392,0l9.645-4.193a1.5,1.5,0,0,0,0-2.753Z']],
  LayersGridDisable: ['layers-grid-disable', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.475a.252.252,0,0,0,.236-.166,7.815,7.815,0,0,1,.419-.97.25.25,0,0,0-.222-.364H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.51a.25.25,0,0,0,.393.205,8.124,8.124,0,0,1,.971-.582.252.252,0,0,0,.136-.223V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.064a.25.25,0,0,0,.22.248,7.878,7.878,0,0,1,1.454.321A.25.25,0,0,0,20,9.4V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.781a.251.251,0,0,0,.211-.116.247.247,0,0,0,.015-.24,7.936,7.936,0,0,1-.514-1.454A.25.25,0,0,0,9.25,19ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M17.25,10.5A6.75,6.75,0,1,0,24,17.25,6.758,6.758,0,0,0,17.25,10.5Zm2.288,2.6a.251.251,0,0,1,.055.4l-6.1,6.1a.249.249,0,0,1-.212.071.253.253,0,0,1-.184-.126,4.7,4.7,0,0,1-.6-2.288,4.756,4.756,0,0,1,4.75-4.75A4.7,4.7,0,0,1,19.538,13.1ZM17.25,22a4.7,4.7,0,0,1-2.288-.6.252.252,0,0,1-.126-.184.249.249,0,0,1,.071-.212l6.1-6.1a.251.251,0,0,1,.4.055A4.7,4.7,0,0,1,22,17.25,4.756,4.756,0,0,1,17.25,22Z']],
  LayersGridAdd: ['layers-grid-add', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.825a.251.251,0,0,0,.233-.159,8.021,8.021,0,0,1,.456-.97.247.247,0,0,0,0-.248.251.251,0,0,0-.215-.123H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.95a.25.25,0,0,0,.4.2,7.976,7.976,0,0,1,.97-.641.249.249,0,0,0,.128-.218V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.294a.251.251,0,0,0,.228.249,7.935,7.935,0,0,1,1.454.265A.25.25,0,0,0,20,9.568V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.927a.25.25,0,0,0,.229-.349,7.869,7.869,0,0,1-.475-1.478A.219.219,0,0,0,9.467,19ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM3,19a1,1,0,0,1-1-1V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm1,7.25a.25.25,0,0,0-.25.25V20a.75.75,0,0,1-1.5,0V18.5a.25.25,0,0,0-.25-.25H15a.75.75,0,0,1,0-1.5h1.5a.25.25,0,0,0,.25-.25V15a.75.75,0,0,1,1.5,0v1.5a.25.25,0,0,0,.25.25H20a.75.75,0,0,1,0,1.5Z']],
  LayersGridHide: ['layers-grid-hide', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M9.5,14.75a.75.75,0,0,0,0-1.5H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v3a.75.75,0,0,0,1.5,0V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8v2.5a1,1,0,0,0,2,0V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H7.5a1,1,0,0,0,1-1,.978.978,0,0,0-.615-.9.218.218,0,0,1-.135-.2V15A.25.25,0,0,1,8,14.75ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6V3A1,1,0,0,1,3,2ZM6.25,18.75A.25.25,0,0,1,6,19H3a1,1,0,0,1-1-1V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25Z', 'M23.8,13.4a1,1,0,0,0-1.4-.2l-12,9A1,1,0,0,0,11,24a.989.989,0,0,0,.6-.2l12-9A1,1,0,0,0,23.8,13.4Z', 'M12.023,20.2a1,1,0,0,0,.088-1.412.438.438,0,0,1,0-.582A6.564,6.564,0,0,1,17,16a1,1,0,0,0,0-2,8.57,8.57,0,0,0-6.389,2.886,2.439,2.439,0,0,0,0,3.229A1,1,0,0,0,12.023,20.2Z', 'M23.389,16.885a1,1,0,1,0-1.5,1.324.439.439,0,0,1,0,.582A6.564,6.564,0,0,1,17,21a1,1,0,0,0,0,2,8.573,8.573,0,0,0,6.388-2.884,2.44,2.44,0,0,0,0-3.231Z']],
  LayersGridSubtract: ['layers-grid-subtract', 24, 24, [{
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }, {
    fill: '#000000',
    stroke: 'none',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': 0
  }], ['M8,19a.25.25,0,0,1-.25-.25V15A.25.25,0,0,1,8,14.75H9.825a.251.251,0,0,0,.233-.159,8.021,8.021,0,0,1,.456-.97.247.247,0,0,0,0-.248.251.251,0,0,0-.215-.123H8A.25.25,0,0,1,7.75,13V8A.25.25,0,0,1,8,7.75h4a.25.25,0,0,1,.25.25v2.95a.25.25,0,0,0,.4.2,7.976,7.976,0,0,1,.97-.641.249.249,0,0,0,.128-.218V8A.25.25,0,0,1,14,7.75h3.75A.25.25,0,0,1,18,8V9.294a.251.251,0,0,0,.228.249,7.935,7.935,0,0,1,1.454.265A.25.25,0,0,0,20,9.568V3a3,3,0,0,0-3-3H3A3,3,0,0,0,0,3V18a3,3,0,0,0,3,3H9.927a.25.25,0,0,0,.229-.349,7.875,7.875,0,0,1-.47-1.455.25.25,0,0,0-.244-.2ZM6.25,13a.25.25,0,0,1-.25.25H2.25A.25.25,0,0,1,2,13V8a.25.25,0,0,1,.25-.25H6A.25.25,0,0,1,6.25,8ZM8,6.25A.25.25,0,0,1,7.75,6V2.25A.25.25,0,0,1,8,2h4a.25.25,0,0,1,.25.25V6a.25.25,0,0,1-.25.25ZM18,3V6a.25.25,0,0,1-.25.25H14A.25.25,0,0,1,13.75,6V2.25A.25.25,0,0,1,14,2h3A1,1,0,0,1,18,3ZM2,3A1,1,0,0,1,3,2H6a.25.25,0,0,1,.25.25V6A.25.25,0,0,1,6,6.25H2.25A.25.25,0,0,1,2,6ZM2,18V15a.25.25,0,0,1,.25-.25H6a.25.25,0,0,1,.25.25v3.75A.25.25,0,0,1,6,19H3A1,1,0,0,1,2,18Z', 'M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11ZM15,18.25a.75.75,0,0,1,0-1.5h5a.75.75,0,0,1,0,1.5Z']]
};
exports["default"] = _default;